import { request } from '@lib/request';

export function getFreeCashBalanceSummary() {
    return request({
        method: 'get',
        url: '/api/balance-asset/free-cash-balance',
    });
}

export function getFunderDetail() {
    return request({
        method: 'get',
        url: '/api/funder'
    });
}

export function getFunderAgreementPreSignedUrl() {
    return request({
        method: 'get',
        url: '/api/funder/funder-agreement'
    })
}
